var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { PureComponent } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Avatar, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { generateUUID, trigger } from '@philips-internal/oswald-ui-utils';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import radiologyLabIcon from '../../assets/images/avatars/radiology_lab.svg';
import laboratoryIcon from '../../assets/images/avatars/avatar_lab.svg';
import './card-exams-title.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
let CardExamsTitle = class CardExamsTitle extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            data: {},
            visible: true,
            width: 12
        };
    }
    static { this.propTypes = {
        nmExame: string,
        nmPessoaFisica: string,
        onClick: eventListener,
        type: string
    }; }
    getExamIcon(examType) {
        switch (examType) {
            case 'N':
                return radiologyLabIcon;
            case 'L':
                return laboratoryIcon;
            case 'P':
                return laboratoryIcon;
            default:
                return '';
        }
    }
    render() {
        const { onClick, nmExame, nmPessoaFisica, type } = this.props;
        const imageExame = this.getExamIcon(type);
        const exameName = type === 'L' ? MessageService.translate(nmExame) : nmExame;
        return (React.createElement(Card, { uuid: generateUUID(), className: 'card-exams-title', onClick: trigger(onClick, new ClickEvent()), width: 12, selectionType: SelectionType.NONE },
            React.createElement("div", { className: 'card-avatar' },
                React.createElement(Avatar, { image: imageExame })),
            React.createElement("div", { className: 'card-content' },
                React.createElement("div", { className: 'content-exame-name' }, exameName),
                React.createElement("div", { className: 'content-physician-name' }, `${MessageService.translate('patient.requested-by')} ${nmPessoaFisica}`))));
    }
};
CardExamsTitle = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
], CardExamsTitle);
export default CardExamsTitle;
//# sourceMappingURL=card-exams-title.js.map